import React from 'react';
import { Box, Typography } from '@mui/joy';
import { useDroppable } from '@dnd-kit/core';
import { CheckCircle, XCircle } from '@phosphor-icons/react';

interface OpportunityDropFooterProps {
  isActive: boolean;
}

export const OpportunityDropFooter: React.FC<OpportunityDropFooterProps> = ({ isActive }) => {
  const { isOver: isOverWon, setNodeRef: setWonRef } = useDroppable({
    id: 'opportunity-won',
  });

  const { isOver: isOverLost, setNodeRef: setLostRef } = useDroppable({
    id: 'opportunity-lost',
  });

  if (!isActive) return null;

  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        display: 'flex',
        height: 140,
        backgroundColor: 'background.surface',
        borderTop: '1px solid',
        borderColor: 'divider',
        boxShadow: 'lg',
        zIndex: 1000,
      }}
    >
      {/* Won Drop Zone */}
      <Box
        ref={setWonRef}
        sx={{
          flex: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 2,
          backgroundColor: isOverWon ? 'success.softBg' : 'transparent',
          borderRight: '1px solid',
          borderColor: 'divider',
          transition: 'background-color 0.2s',
          cursor: 'pointer',
        }}
      >
        <CheckCircle size={32} color={isOverWon ? '#0d7a0d' : '#4caf50'} />
        <Typography
          level="h4"
          sx={{
            color: isOverWon ? 'success.solid' : 'success.main',
            fontWeight: 'bold',
          }}
        >
          Mark as Won
        </Typography>
      </Box>

      {/* Lost Drop Zone */}
      <Box
        ref={setLostRef}
        sx={{
          flex: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 2,
          backgroundColor: isOverLost ? 'danger.softBg' : 'transparent',
          transition: 'background-color 0.2s',
          cursor: 'pointer',
        }}
      >
        <XCircle size={32} color={isOverLost ? '#d32f2f' : '#f44336'} />
        <Typography
          level="h4"
          sx={{
            color: isOverLost ? 'danger.solid' : 'danger.main',
            fontWeight: 'bold',
          }}
        >
          Mark as Lost
        </Typography>
      </Box>
    </Box>
  );
};